import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    max: 'Max',
    amount: 'Amount',
    defaultBalanceText: 'Balance:',
    balance: '{balance}: {value}',
  },
};
